<template>
  <div>
    <div class="userContainer">
      <div class="user">
        <div class="title">增值税专票开票信息</div>
        <div class="inputContainer">
          <div class="inputItem">
            <label for="duty">公司税号</label>
            <input type="text" id="duty" v-model="duty" />
          </div>
          <div class="inputItem">
            <label for="bank">开户银行</label>
            <input type="text" id="bank" v-model="bank" />
          </div>
          <div class="inputItem">
            <label for="user"
              >账&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;号&nbsp;&nbsp;</label
            >
            <input type="text" id="user" v-model="user" />
          </div>
          <div class="inputItem">
            <label for="liaisons">财务联络人</label>
            <input type="text" id="liaisons" v-model="liaisons" />
          </div>
          <div class="inputItem">
            <label for="phone">联系电话</label>
            <input type="text" id="phone" v-model="phone" />
          </div>
          <div class="inputItem">
            <label for="site">地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址</label>
            <input type="text" id="site" v-model="site" />
          </div>
          <div class="btn">
            <button @click="amendSave">保存</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserInfo, savetaxinfo } from "@/api";
export default {
  data() {
    return {
      duty: "",
      bank: "",
      user: "",
      liaisons: "",
      phone: "",
      site: "",
      userDataInfo: {},
    };
  },
  methods: {
    async userInfo() {
      let token = window.sessionStorage.getItem("token");
      let usercode = window.sessionStorage.getItem("usercode");
      const { data: res } = await getUserInfo({
        usercode,
        token,
      });
      let userInfoData = JSON.parse(res);
      this.userDataInfo = userInfoData[0];
      this.duty = this.userDataInfo.taxnum;
      this.bank = this.userDataInfo.bankname;
      this.user = this.userDataInfo.bankaccount;
      this.liaisons = this.userDataInfo.cwperson;
      this.phone = this.userDataInfo.cwphone;
      this.site = this.userDataInfo.cwaddress;
    },
    async amendSave() {
      const { duty, bank, user, liaisons, phone, site } = this;
      if (duty && bank && user && liaisons && phone && site) {
        let usercode = window.sessionStorage.getItem("usercode");
        let token = window.sessionStorage.getItem("token");
        const { data: res } = await savetaxinfo({
          usercode,
          token,
          taxaccount: duty,
          bankname: bank,
          bankaccount: user,
          cwperson: liaisons,
          cwphone: phone,
          address: site,
        });
        let result = JSON.parse(res)[0];
        if (result.code !== 200) {
          this.$notify.error({
            title: "错误",
            message: result.message,
            duration: 1000,
          });
        } else {
          this.$notify({
            title: "成功",
            message: result.message,
            type: "success",
            duration: 1000,
          });
          this.userInfo();
        }
      } else {
        this.$notify.error({
          title: "错误",
          message: "所填信息不能为空!",
          duration: 1000,
        });
      }
    },
  },
  mounted() {
    this.userInfo();
  },
};
</script>
<style lang='less' scoped>
.userContainer {
  border: 1px solid #dbdbdb;
  width: 1025px;
  .user {
    .inputContainer {
      padding-left: 30px;
      .btn {
        padding: 60px 0 100px 60px;
        button {
          width: 110px;
          height: 30px;
          background: #e4040c;
          color: #fff;
          cursor: pointer;
        }
      }
      .inputItem {
        padding-top: 20px;
        label {
          display: inline-block;
          width: 70px;
        }
        input {
          text-indent: 10px;
          width: 180px;
          height: 25px;
          border: 1px solid #cccccc;
        }

        #site,
        #bank {
          width: 500px;
        }
      }
    }
    .title {
      height: 35px;
      line-height: 35px;
      background: #f3f4f6;
      border-bottom: 1px solid #dbdbdb;
      text-indent: 30px;
    }
  }
}
</style>